import React from 'react';
import { ArrowRight } from 'lucide-react';
export function RecentPatients() {
  const patients = [{
    initials: 'MR',
    name: 'Maria Rodriguez',
    details: 'Breast · Houston',
    status: '3D ready',
    avatarBg: 'bg-[#4ac88a]/10',
    avatarText: 'text-[#4ac88a]',
    chipBg: 'bg-[#4ac88a]/10',
    chipText: 'text-[#4ac88a]'
  }, {
    initials: 'SG',
    name: 'Sofia Gonzalez',
    details: 'Body · Miami',
    status: 'Uploaded',
    avatarBg: 'bg-[#4a8adc]/10',
    avatarText: 'text-[#4a8adc]',
    chipBg: 'bg-[#4a8adc]/10',
    chipText: 'text-[#4a8adc]'
  }, {
    initials: 'AL',
    name: 'Ana Lopez',
    details: 'Face · Las Vegas',
    status: 'Pending',
    avatarBg: 'bg-[#d8902a]/10',
    avatarText: 'text-[#d8902a]',
    chipBg: 'bg-[#d8902a]/10',
    chipText: 'text-[#d8902a]'
  }, {
    initials: 'KM',
    name: 'Karen Mendez',
    details: 'Breast · Phoenix',
    status: 'Viewed 3D',
    avatarBg: 'bg-[#9a70dc]/10',
    avatarText: 'text-[#9a70dc]',
    chipBg: 'bg-[#9a70dc]/10',
    chipText: 'text-[#9a70dc]'
  }, {
    initials: 'LT',
    name: 'Lucia Torres',
    details: 'Body · Houston',
    status: '3D ready',
    avatarBg: 'bg-[#4ac88a]/10',
    avatarText: 'text-[#4ac88a]',
    chipBg: 'bg-[#4ac88a]/10',
    chipText: 'text-[#4ac88a]'
  }];
  return <div className="bg-[#060c18] border border-[#0e1826] rounded-xl p-6 flex flex-col h-full" data-id="element-73">
      <div className="flex items-center justify-between mb-6" data-id="element-74">
        <h2 className="text-lg font-bold text-[#f0ead8]" data-id="element-75">Recent patients</h2>
        <button className="text-sm font-medium text-[#b8a06a] hover:text-[#f0ead8] transition-colors flex items-center gap-1" data-id="element-76">
          View all <ArrowRight className="w-4 h-4" data-id="element-77" />
        </button>
      </div>

      <div className="flex flex-col gap-5 flex-1 justify-between" data-id="element-78">
        {patients.map((patient, i) => <div key={i} className="flex items-center justify-between" data-id="element-79">
            <div className="flex items-center gap-4" data-id="element-80">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold text-sm ${patient.avatarBg} ${patient.avatarText}`} data-id="element-81">
                {patient.initials}
              </div>
              <div className="flex flex-col" data-id="element-82">
                <span className="text-sm font-bold text-[#f0ead8]" data-id="element-83">
                  {patient.name}
                </span>
                <span className="text-xs text-[#3a5070]" data-id="element-84">
                  {patient.details}
                </span>
              </div>
            </div>
            <div className={`px-2.5 py-1 rounded-md text-xs font-semibold ${patient.chipBg} ${patient.chipText}`} data-id="element-85">
              {patient.status}
            </div>
          </div>)}
      </div>
    </div>;
}